import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function hasVisibleLabel(field: SchemaField): boolean {
  return typeof field.label === 'string' ? field.label.trim().length > 0 : Boolean(field.label)
}
